import { NgModule } from '@angular/core';
import { MatFormFieldModule, MatInputModule } from '@angular/material';
import { sharedModule } from "src/app/shared/shared.module";
import { ReportComponent } from './report.component';
// import { PlacementReportComponent } from './placement-report/placement-report.component';
// import { RegistrationReportComponent } from './registration-report/registration-report.component';
import { FinancialReportComponent } from './financial-report/financial-report.component';
import { EducationReportComponent } from './education-report/education-report.component';
import { SalaryReportComponent } from './salary-report/salary-report.component';
import { EduOrgReportComponent } from './edu-org-report/edu-org-report.component';
import { ManagementReportComponent } from './management-report/management-report.component';

@NgModule({
  declarations: [
    ReportComponent,
    // PlacementReportComponent,
    // RegistrationReportComponent,
    FinancialReportComponent,
    EducationReportComponent,
    SalaryReportComponent,
    EduOrgReportComponent,
    ManagementReportComponent
  ],
  imports: [sharedModule, MatFormFieldModule,
    MatInputModule],
  entryComponents: []
})
export class ReportModule { }
